// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
// Engine controllers register here, not in controllers/index.js: that
// manifest is regenerated by stimulus:manifest:update, which only knows
// app/javascript/controllers and would drop the import (docs/icomos.md)
import "../../engines/icomos/app/javascript/controllers"

// Lexxy, the app-wide rich text editor over Action Text (docs/text-ric.md);
// Active Storage powers its direct uploads
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
import "@37signals/lexxy"
